module.exports = "/work-site/img/alarm.beb27b40.png";